<!--
 * =====================================================================
 * 작 업 명  : 회원가입
 * 파 일 명  : Join.vue
 * 변경이력
 * 2022-01-29 / 정태화 / 최초작성
 * 2022-02-15 / 경다찬 / 메일 발송, 수신 코드, ID 중복체크 작성
 * 2022-03-10 / 임태민 / 컴포넌트 분리, 모듈화
 * 2022-03-10 / 임태민 / 기능 및 유효성체크 추가, 수정
 * 2022-03-10 / 임태민 / 글자수 제한
 * =====================================================================
 -->
<template>
  <div>
    <div class="text mt-3 mb-4">
      <p class="h4"><b>Email Verification</b></p>
    </div>
    <div class="text mb-5">
      <p class="h5">We have sent you an email with a verification code.</p>
    </div>
    <div class="row">
      <div class="col">
        <div class="">
          <div class="form-floating">
            <input
              type="text"
              class="form-control"
              id="user-code"
              v-model="this.userChild.USER_CODE"
              required
            />
            <label for="user-code"
              ><span class="required">*</span>Verification Code</label
            >
          </div>
        </div>
        <div ref="VERIFY_CODE" class="black" role="alert"/>
      </div>
    </div>
    <div class="row">
      <div ref="EMAIL" class="check" role="alert">&nbsp;</div>
    </div>
    <div class="row">
      <div class="col mt-3 mb-3">
        <button
          type="button"
          class="btn btn-outline-dark btn-lg rounded-pill w-100"
          @click="prev()"
        >
          Back
        </button>
      </div>
      <div class="col mt-3 mb-3">
        <button
          type="button"
          class="btn btn-outline-dark btn-lg rounded-pill w-100"
          @click="verify()"
        >
          Next
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import "@/assets/css/formLayout.css";
import { $axios, $error } from "@/dot-ui/index.js";
import { Join } from "@/js/user/Join.js";

export default {
  props: ["user", "fromParams"],
  data() {
    return {
      userChild: {},
    };
  },
  created() {
    this.userChild = this.user;
  },
  methods: {
    // 이메일 인증코드 발송
    async sendCode() {
      this.userChild.USER_CODE = "";

      let url = "/user-app/v2/users/email-verification/send";
      let param = this.userChild;
      let response = await $axios.post(url, param);

      if (response.status === 200) {
        this.$refs.EMAIL.innerHTML =
          "Please check the verification code in the email you entered.";
        Join.setColorClass(this.$refs.EMAIL, "green");
      } else {
        this.$refs.EMAIL.innerHTML = "Send Mail failed to send message.";
        Join.setColorClass(this.$refs.EMAIL, "red");
      }
    },
    // 이메일 인증코드 검증
    async verify() {
      // 클래스(.check) 폼 초기화
      $error.clearForm("check");

      let url = "/user-app/v2/users/email-verification/verify";
      let param = this.userChild;
      let response = await $axios.post(url, param);
      let json = response.data;

      if (response.status === 200) {
        // 사이트회원
        if (json.RESULT_CODE === "2") {
          this.next(json.RESULT_CODE);
          // 신규회원
        } else if (json.RESULT_CODE === "1") {
          this.next(json.RESULT_CODE);
          // 기타
        } else {
          console.log();
        }
      } else {
        $error.showMessage(response, this);
        $error.focus(response);
      }
    },
    // 이전화면으로 이동
    prev() {
      this.$emit("prev", this.userChild, "showJoin1");
    },
    // 다음화면으로 이동
    next(status) {
      if (status == 2) {
        this.$emit("changeData", this.userChild, "showJoin4");
      }
      if (status == 1) {
        this.$emit("changeData", this.userChild, "showJoin3");
      }
    },
  },
};
</script>
<style></style>
